import { ErrorHandler, inject, Injectable } from '@angular/core'
import { WindowToken } from '@shared/tokens'
import { CHUNK_LOAD_ERROR_RELOAD } from '../../app.config'
import { BrowserSessionStorageService } from '@shared/services/browser-session-storage.service'
import { ErrorLogService } from '@shared/services/error-log.service'

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  private w = inject(WindowToken)
  private storage = inject(BrowserSessionStorageService)
  private errorLogService = inject(ErrorLogService)
  private handlingError = false

  handleError(error: any) {
    this.errorLogService.log(error, 'ErrorHandlerService', '')

    // Prevent recursive error handling loops from overflowing the stack.
    if (this.handlingError) {
      return
    }

    this.handlingError = true
    const errorMessage = error?.message || (typeof error === 'string' ? error : '')
    const chunkFailedMessage =
      /Loading chunk|ChunkLoadError|Failed to fetch dynamically imported module|Importing a module script failed/i
    try {
      if (chunkFailedMessage.test(errorMessage)) {
        console.warn('Chunk load error, reloading...', error)
        const hasReloaded = this.storage.get(CHUNK_LOAD_ERROR_RELOAD)
        if (!hasReloaded) {
          console.error('Chunk load error detected and start reload.', error)
          this.storage.set(CHUNK_LOAD_ERROR_RELOAD, 'true')
          if (this.w?.location) {
            this.w.location.reload()
          } else {
            console.error('Window location not available for reload')
          }
        } else {
          console.error('Chunk load error detected and reload been made.', error)
          this.storage.remove(CHUNK_LOAD_ERROR_RELOAD)
        }
      } else {
        console.error(error)
      }
    } finally {
      this.handlingError = false
    }
  }
}
